import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import AttachScannerCaseSearch from './attach-scanner-case-search.component';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';
import { ScannerCase } from 'models/scanner-case';

type AttachScannerCaseDialogProps = {
    onClose: (scannerCase?: ScannerCase) => void;
    open: boolean;
    orderId: string;
    pin: string;
    name: string;
};
const AttachScannerCaseDialog: FC<AttachScannerCaseDialogProps> = ({ onClose, open, orderId, pin, name }) => {
    const { t: translate } = useTranslation(['common', 'scan-cases']);

    return (
        <DHDialog
            fullWidth
            open={open}
            onClose={() => onClose()}
            maxWidth="lg"
            title={translate('scan-cases:ATTACH_SCANS')}
        >
            <AttachScannerCaseSearch
                onAttach={(scannerCase: ScannerCase) => onClose(scannerCase)}
                orderId={orderId}
                pin={pin}
                name={name}
            />
        </DHDialog>
    );
};

export default AttachScannerCaseDialog;
